// import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as ReactDOMClient from 'react-dom/client';
// import App from './App';
import * as Sentry from "@sentry/react";
import { App } from './App';
// import reportWebVitals from './reportWebVitals';
// import registerServiceWorker from './registerServiceWorker';
import { onLCP } from 'web-vitals';
import { initializePolarisWebComponents } from './utils/polarisWebComponents';

// Initialize Polaris Web Components
initializePolarisWebComponents();

onLCP(console.log);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const root = ReactDOMClient.createRoot(document.getElementById('root'));
Sentry.init({
  dsn: "https://f805ee4b96ce4fb1aa0794668911adcd@o159522.ingest.sentry.io/4504616064778240",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});
root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>);
// reportWebVitals(console.log);
// registerServiceWorker();

